module.exports = __webpack_public_path__ + "38bd916a79c651d48bae75eba79ad821.MP3";